<template>
<div>  
    <section class="page-section bg-lq-dark-blue py-1" id="servicesection">
        <div class="container">
          <h1 class="text-center mt-0 section-title">
            <a style="font-size: 27px; color: white;">
                  {{ $t('textService') }}
            </a>
          </h1>
        </div>
    </section>    
</div>
</template>

<script>
import { setTimeout } from 'timers';
import lazyLoadComponent from '../utils/lazy-load-component';
import SkeletonLoading from './utils/SkeletonLoading';

const defaultOptions = {
  loading: SkeletonLoading,
  loadingData: {
    props: {
      width: `100%`,
      height: `20em`,
    },
  },
};
export default {
   name: 'ServiceSection' ,
   components: {
   },
    mounted() {
        this.$nextTick(() => {
            // alert('partner section finish loaded')
            this.$emit('isSitemapSection', 'sitemapSectionActive')
        });       
    },
   computed: {
    
  },   
  methods: {
    
  },
}
</script>

<style scoped>
h1 {
  font-family: 'QuattrocentoRegular', 'Rubik', sans-serif;
}
.bg-lq-dark-blue {
    background-color: #053448;
}
.roboto-font {
  text-align: center;
  font-family: 'RobotoLight'!important;
  font-weight: 300!important;
  color:#053448!important;
}

</style>
